import { IVenueListItem } from '@core/interfaces/venue/venue-list-item.interface';
import { IListResult } from '@core/interfaces/list-result/list-result.interface';
import { ADDRESS_MOCK } from '../address/address.mock';
import { ICityInfo } from '../../interfaces/venue/city-info.interface';

export const VENUE_LIST: IListResult<IVenueListItem> = {
  results: [
    {
      id: '4bab161a-5363-48f6-80f3-08ef2482615f',
      partnerId: '3d285934-00a3-4914-a3a9-49df44609e07',
      name: 'Kis Tálló',
      address: ADDRESS_MOCK,
    },
    {
      id: '54705db8-df14-4746-942d-cc6ebaadd2c9',
      partnerId: '7fd46806-cddd-46f8-b47c-9112ff4ecddc',
      name: 'Nagy Tálló',
      address: ADDRESS_MOCK,
    },
    {
      id: 'd5458323-51fd-4164-9581-dc0f0f6b2456',
      partnerId: '342ca190-efd5-4ac1-b41d-c900e2025b7e',
      name: 'Vad Álló',
      address: ADDRESS_MOCK,
    },
  ],
  resultsLength: 3,
};

export const CITY_INFO: ICityInfo = {
  zipCode: '2040',
  cities: ['Budaörs', 'Budakeszi'],
  county: 'Pest',
};
